import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from './api.service';
import { PaymentIntentResponseInterface } from '../models/payment-intent-response.interface';
import { HttpClient } from '@angular/common/http';
import { CardInterface } from '../../account/models/card.interface';
import { ExtranetService } from './extranet.service';

@Injectable()
export class PartnerPaymentService {

  constructor(
      private apiService: ApiService,
      private http: HttpClient,
      private extranetService: ExtranetService
  ) {}

  /**
   * Create payment intent
   * @param body
   */
  createPaymentIntent(body: any): Observable<PaymentIntentResponseInterface> {
    const headers = { Authorization: `Bearer ${this.apiService.getToken().token}` };
    return this.http.post<PaymentIntentResponseInterface>(`${environment.data.apiPaymentUrl}/create/payment/intent`, body, { headers });
  }

  /**
   * Check data before payment
   * @param paymentIntentId
   */
  checkBeforePayment(paymentIntentId: string): Observable<any> {
    const headers = { Authorization: `Bearer ${this.apiService.getToken().token}` };
    const splitHostname = window.location.hostname.split('.');
    let apiURL = environment.data.apiUrl;
    if (splitHostname.length > 0 && splitHostname[0].includes('extec')) {
      apiURL = environment.data.extEcApiUrl;
    }
    return this.http.post<any>(`${apiURL}check/before/payment`, {eventId: paymentIntentId}, { headers });
  }

  /**
   * Delete card
   * @param paymentMethod
   * @param password
   */
  deleteCard(paymentMethod: string, password: string): Observable<any> {
    const headers = {'Authorization': 'Bearer ' + this.apiService.getToken().token};
    let extranetToken = null;
    if (this.extranetService.getSupportUser()) {
      extranetToken = this.extranetService.getSupportUser().token;
    }
    return this.http.post<any>(`${environment.data.apiPaymentUrl}/delete/payment/method`, {paymentMethod, password, extranetToken}, { headers });
  }

  /**
   * Get customer cards
   */
  getCards(): Observable<Array<CardInterface>> {
    const headers = { Authorization: `Bearer ${this.apiService.getToken().token}` };
    return this.http.get<Array<CardInterface>>(`${environment.data.apiPaymentUrl}/payment/cards`, {headers});
  }

  /**
   * Update selected card
   * @param paymentMethod
   * @param password
   */
  updateSelectedCard(paymentMethod: string, password: string): Observable<any> {
    const headers = {'Authorization': 'Bearer ' + this.apiService.getToken().token};
    let extranetToken = null;
    if (this.extranetService.getSupportUser()) {
      extranetToken = this.extranetService.getSupportUser().token;
    }
    return this.http.put<any>(`${environment.data.apiPaymentUrl}/update/selected/card`, {paymentMethod, password, extranetToken}, {headers});
  }
}
